import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { thunkSetPanelPositionSetting } from '../../../redux/actions/selfDataActions';
import { selectPanelPositionSetting } from '../../../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_PANEL_POSITION_PROPERTIES, ALL_PANEL_POSITION_SETTINGS } from '../../../types/layoutModeTypes';
import { isMobileDeviceForLayoutMode } from '../../../utils/layoutModeUtils';
import { ClientSettingModalItem } from './clientSettingModalItem';
function getNextPanelPositionIndex(currPanelPositionIndex) {
    return currPanelPositionIndex === -1 ? 0 : (currPanelPositionIndex + 1) % ALL_PANEL_POSITION_SETTINGS.length;
}
function getNextAvailablePanelPositionIndex(panelPositionSetting) {
    const currPanelPositionIndex = ALL_PANEL_POSITION_SETTINGS.indexOf(panelPositionSetting);
    let nextPanelPositionIndex = getNextPanelPositionIndex(currPanelPositionIndex);
    if (!isMobileDeviceForLayoutMode()) {
        return nextPanelPositionIndex;
    }
    // not all panel positions are supported on mobile, so skip over those that are not:
    while (!ALL_PANEL_POSITION_PROPERTIES[ALL_PANEL_POSITION_SETTINGS[nextPanelPositionIndex]].isAvailableOnMobile) {
        nextPanelPositionIndex = getNextPanelPositionIndex(nextPanelPositionIndex);
    }
    return nextPanelPositionIndex;
}
export const PanelPositionSettingModalItem = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const panelPositionSetting = useAppSelector(selectPanelPositionSetting);
    const onClick = useCallback(() => {
        const nextPanelPositionIndex = getNextAvailablePanelPositionIndex(panelPositionSetting);
        dispatch(thunkSetPanelPositionSetting(ALL_PANEL_POSITION_SETTINGS[nextPanelPositionIndex]));
    }, [dispatch, panelPositionSetting]);
    const { label } = ALL_PANEL_POSITION_PROPERTIES[panelPositionSetting];
    const autoModeNote = isMobileDeviceForLayoutMode()
        ? '"Auto" will adjust panels based on whether your device is vertical or horizontal.'
        : '"Auto" will adjust panels based on window dimensions.';
    return (_jsx(ClientSettingModalItem, { settingName: 'Panel Position', settingDescription: `Affects whether panels will be on the right or top. ${autoModeNote}`, buttonLabel: label, onClick: onClick, onClose: onClose }));
};
